import {
  ShieldCheck, TrendingUp, Cpu, ShieldAlert, Landmark, GraduationCap,
  Plane, Navigation, Gem, Building2, Wrench, Rocket, Globe2,
  FileText, Server, Users, Layers, Radar, ClipboardCheck,
  Scale, TriangleAlert, Workflow, LayoutDashboard, FileSearch, GitCompare, BarChart3,
} from "lucide-react";

const MAP = {
  ShieldCheck, TrendingUp, Cpu, ShieldAlert, Landmark, GraduationCap,
  Plane, Navigation, Gem, Building2, Wrench, Rocket, Globe2,
  FileText, Server, Users, Layers, Radar, ClipboardCheck,
  Scale, TriangleAlert, Workflow, LayoutDashboard, FileSearch, GitCompare, BarChart3,
};

export function Icon({ name, className }) {
  const Cmp = MAP[name] || ShieldCheck;
  return <Cmp className={className} aria-hidden="true" />;
}
